import { createContext, useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  addPersonnelCommentService,
  createPersonnelService,
  deletePersonnelDocumentService,
  deletePersonnelService,
  editPersonnelsService,
  getCategoryItemsService,
  getFailureRequestsService,
  getInvoicesService,
  getPaymentTransactionsService,
  getPersonnelDocumentService,
  getPersonnelService,
  getPersonnelsService,
  getServicesService,
  getViolationsService,
  uploadPersonnelDocumentService,
  getLogsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { getCustomCalendarDate, validateFile } from "../../../utils";

export const personnelAdminContext = createContext({
  categories: [],
  setCategories: () => { },
  personnels: [],
  setPersonnels: () => { },
  services: [],
  setServices: () => { },
  violations: [],
  setViolations: () => { },
  failureRequests: [],
  setFailureRequests: () => { },
  invoices: [],
  setInvoices: () => { },
  paymentTransactions: [],
  setPaymentTransactions: () => { },
  personnel: {},
  setPersonnel: () => { },
  search: "",
  setSearch: () => { },
  filterExpertType: null,
  setFilterExpertType: () => { },
  filterActivityType: null,
  setFilterActivityType: () => { },
  handleApplyPersonnelFilters: () => { },
  handleShowCreateModal: () => { },
  type: null,
  setType: () => { },
  totalCount: null,
  setTotalCount: () => { },
  pageNumber: null,
  setPageNumber: () => { },
  limit: null,
  setLimit: () => { },
  detailsTotalCount: null,
  setDetailsTotalCount: () => { },
  detailsPageNumber: null,
  setDetailsPageNumber: () => { },
  detailsLimit: null,
  setDetailsLimit: () => { },
  expertiseSearch: "",
  setExpertiseSearch: () => { },
  from_registry_date: "",
  setFrom_registry_date: () => { },
  to_registry_date: "",
  setTo_registry_date: () => { },
  from_quit_date: "",
  setFrom_quit_date: () => { },
  to_quit_date: "",
  setTo_quit_date: () => { },
  activeTab: "",
  setActiveTab: () => { },
  // Personnel Create And Update Item
  id: "",
  setId: () => { },
  first_name: "",
  gender: "",
  setGender: () => { },
  setFirst_name: () => { },
  last_name: "",
  setLast_name: () => { },
  username: "",
  setUsername: () => { },
  mobile: "",
  setMobile: () => { },
  about_me: "",
  setAbout_me: () => { },
  birth_date: "",
  setBirth_date: () => { },
  father_name: "",
  setFather_name: () => { },
  phone_numbers: "",
  setPhone_numbers: () => { },
  business_address: "",
  setBusiness_address: () => { },
  balance: "",
  setBalance: () => { },
  balanceFilter: "",
  setBalanceFilter: () => { },
  shaba: "",
  setShaba: () => { },
  cooperation_percentage: "",
  setCooperation_percentage: () => { },
  initial_invest: "",
  setInitial_invest: () => { },
  vacation: {},
  setVacation: () => { },
  to_date: "",
  setTo_date: () => { },
  from_date: "",
  setFrom_date: () => { },
  status: "",
  setStatus: () => { },
  isSpecial: "",
  setIsSpecial: () => { },
  is_contractor: null,
  setIs_contractor: () => { },
  selectedTechnicians: [],
  setSelectedTechnicians: () => { },
  searchedPersonnels: [],
  setSearchedPersonnels: () => { },
  isPersonnelLoading: false,
  setIsPersonnelLoading: () => { },
  personnelSearch: "",
  setPersonnelSearch: () => { },
  handleRemovePersonnel: () => { },
  handleAddPersonnel: () => { },
  triggerSearch: () => { },
  role_filter: "",
  setRole_filter: () => { },
  parent_contractor_filter: "",
  setParent_contractor_filter: () => { },
  contractorsList: [],
  setContractorsList: () => { },
  handleGetContractorsList: () => { },
  isActive: "",
  setIsActive: () => { },
  items: [],
  setItems: () => { },
  deleted_items: [],
  setDeleted_items: () => { },
  is_active: null,
  setIs_active: () => { },
  is_special: null,
  setIs_special: () => { },
  isShowModal: null,
  setIsShowModal: () => { },
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => { },
  expert_type: null,
  setExpert_type: () => { },
  activity_type: null,
  setActivity_type: () => { },
  working_by_foolad: null,
  setWorking_by_foolad: () => { },
  sort_by: "",
  setSort_by: () => { },
  description: "",
  setDescription: () => { },
  expertise: [],
  setExpertise: () => { },
  isShowExpertiseModal: null,
  isSelectExpertise: () => { },
  isShowAdvancedSearch: null,
  setIsShowAdvancedSearch: () => { },
  setIsShowExpertiseModal: () => { },
  handleShowExpertiseModal: () => { },
  handleCloseExpertiseModal: () => { },
  handleShowDetailsModal: () => { },
  handleCloseDetailsModal: () => { },
  handleShowModal: () => { },
  handleCloseModal: () => { },
  handleGetCategories: () => { },
  handleGetViolations: () => { },
  handleGetFailureRequests: () => { },
  handleGetInvoices: () => { },
  handleGetPaymentTransactions: () => { },
  handleGetPersonnels: () => { },
  handleDeletePersonnel: () => { },
  handleCreatePersonnel: () => { },
  handleGetPersonnel: () => { },
  handleUpdatePersonnelExpertise: () => { },
  handleSearchServices: () => { },
  handleGetServices: () => { },
  handleEditPersonnel: () => { },
  handleAddComment: () => { },
  handleDateRange: () => { },
  handleUploadDocument: () => { },
  handleDeleteDocument: () => { },
  handleGetDocument: () => { },
  city_filter: "",
  setCity_filter: () => { },
  cities: [],
  setCities: () => { },
  selectedCity: [],
  setSelectedCity: () => { },
});

const PersonnelAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();
  const allCities = useSelector((state) => state.cities);

  const [categories, setCategories] = useState([]);
  const [personnels, setPersonnels] = useState([]);
  const [services, setServices] = useState([]);
  const [violations, setViolations] = useState([]);
  const [failureRequests, setFailureRequests] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [paymentTransactions, setPaymentTransactions] = useState([]);
  const [personnel, setPersonnel] = useState({});
  const [search, setSearch] = useState("");
  const [filterExpertType, setFilterExpertType] = useState(null);
  const [filterActivityType, setFilterActivityType] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const listRequestId = useRef(0);
  const [expert_type, setExpert_type] = useState(null);
  const [activity_type, setActivity_type] = useState(null);
  const [type, setTypeState] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimitState] = useState(100);
  const [detailsTotalCount, setDetailsTotalCount] = useState(0);
  const [detailsPageNumber, setDetailsPageNumber] = useState(1);
  const [detailsLimit, setDetailsLimit] = useState(100);
  const [expertiseSearch, setExpertiseSearch] = useState("");
  const [from_registry_date, setFrom_registry_date] = useState("");
  const [to_registry_date, setTo_registry_date] = useState("");
  const [from_quit_date, setFrom_quit_date] = useState("");
  const [to_quit_date, setTo_quit_date] = useState("");
  const [activeTab, setActiveTab] = useState("0");
  const [sort_by, setSortByState] = useState("-created");
  // Personnel Create And Update Item
  const [id, setId] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [gender, setGender] = useState("");
  const [last_name, setLast_name] = useState("");
  const [username, setUsername] = useState("");
  const [mobile, setMobile] = useState("");
  const [about_me, setAbout_me] = useState("");
  const [birth_date, setBirth_date] = useState("");
  const [father_name, setFather_name] = useState("");
  const [phone_numbers, setPhone_numbers] = useState("");
  const [business_address, setBusiness_address] = useState("");
  const [balance, setBalance] = useState("0");
  const [balanceFilter, setBalanceFilter] = useState("");
  const [shaba, setShaba] = useState("");
  const [description, setDescription] = useState("");
  const [cooperation_percentage, setCooperation_percentage] = useState("0");
  const [initial_invest, setInitial_invest] = useState("0");
  const [vacation, setVacation] = useState({});
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [status, setStatus] = useState("");
  // This state for filter
  const [isSpecial, setIsSpecialState] = useState("All");
  const [is_contractor, setIs_contractor] = useState(null);
  const [selectedTechnicians, setSelectedTechnicians] = useState([]);
  const [initialTechnicianIds, setInitialTechnicianIds] = useState([]);
  const [searchedPersonnels, setSearchedPersonnels] = useState([]);
  const [isPersonnelLoading, setIsPersonnelLoading] = useState(false);
  const [personnelSearch, setPersonnelSearch] = useState("");
  const [role_filter, setRole_filter] = useState("");
  const [parent_contractor_filter, setParent_contractor_filter] = useState("");
  const [contractorsList, setContractorsList] = useState([]);
  const [isActive, setIsActive] = useState("");
  const [items, setItems] = useState([]);
  const [deleted_items, setDeleted_items] = useState([]);
  const [expertise, setExpertise] = useState([]);
  const [is_active, setIs_active] = useState(true);
  const [is_special, setIs_special] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [working_by_foolad, setWorking_by_foolad] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [isShowExpertiseModal, setIsShowExpertiseModal] = useState(false);
  const [isShowAdvancedSearch, setIsShowAdvancedSearch] = useState(false);
  const [city_filter, setCity_filter] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [from_last_successful_job, setFrom_last_successful_job] = useState("");
  const [to_last_successful_job, setTo_last_successful_job] = useState("");
  const [from_last_unsuccessful_job, setFrom_last_unsuccessful_job] = useState("");
  const [to_last_unsuccessful_job, setTo_last_unsuccessful_job] = useState("");
  const [from_last_rejected_job, setFrom_last_rejected_job] = useState("");
  const [to_last_rejected_job, setTo_last_rejected_job] = useState("");
  const [personnelLogs, setPersonnelLogs] = useState([]);

  const setType = (value) => { setTypeState(value); setPageNumber(1); };
  const setLimit = (value) => { setLimitState(value); setPageNumber(1); };
  const setSort_by = (value) => { setSortByState(value); setPageNumber(1); };
  const setIsSpecial = (value) => { setIsSpecialState(value); setPageNumber(1); };

  useEffect(() => {
    setCities(allCities);
  }, [allCities]);

  const resetPersonnelForm = () => {
    setViolations([]);
    setFailureRequests([]);
    setInvoices([]);
    setPaymentTransactions([]);
    setServices([]);
    setPersonnel({});
    setExpertiseSearch("");
    setActiveTab("0");
    setId("");
    setFirst_name("");
    setGender("");
    setLast_name("");
    setUsername("");
    setDescription("");
    setMobile("");
    setAbout_me("");
    setBirth_date("");
    setFather_name("");
    setPhone_numbers("");
    setBusiness_address("");
    setBalance("0");
    setShaba("");
    setCooperation_percentage("0");
    setInitial_invest("0");
    setVacation({});
    setTo_date("");
    setFrom_date("");
    setStatus("");
    setIs_contractor(null);
    setSelectedTechnicians([]);
    setInitialTechnicianIds([]);
    setSelectedCity(null);
    setSearchedPersonnels([]);
    setIsPersonnelLoading(false);
    setPersonnelSearch("");
    setItems([]);
    setExpertise([]);
    setDeleted_items([]);
    setDetailsTotalCount(0);
    setDetailsPageNumber(1);
    setExpert_type(null);
    setActivity_type(null);
    setWorking_by_foolad(false);
    setIs_active(true);
    setIs_special(false);
  };

  // Create Personnel Modal Operations
  const handleShowModal = () => {
    setIsShowModal(true);
  };
  const handleShowCreateModal = () => {
    resetPersonnelForm();
    setIsShowModal(true);
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    resetPersonnelForm();
  };

  // Create Personnel Details Modal Operations
  const handleShowDetailsModal = () => {
    setIsShowDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setPersonnel({});
    resetPersonnelForm();
  };

  // Personnel Expertise Modal Operations
  const handleShowExpertiseModal = () => {
    setIsShowExpertiseModal(true);
  };
  const handleCloseExpertiseModal = () => {
    setIsShowExpertiseModal(false);
    resetPersonnelForm();
  };

  // Handle Get Categories Method
  const handleGetCategories = async (event) => {
    event?.preventDefault();

    try {
      const { status, data } = await getCategoryItemsService();
      if (status === 200) {
        setCategories(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Search Services Method
  const handleSearchServices = async (filter, callback) => {
    const objData = {
      search: filter,
      offset: 0,
      limit: 500,
    };

    try {
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        const services = data.list?.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        callback &&
          callback([
            {
              value: null,
              label: "همه",
            },
            ...services,
          ]);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Services Method
  const handleGetServices = async (categoryId) => {
    const objData = { service_category_id: categoryId, offset: 0, limit: 300 };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        setServices(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Violations Method
  const handleGetViolations = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const search = isSearch ? event.target?.search?.value : "";

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      search,
      offset: ((isSearch ? 1 : detailsPageNumber) - 1) * detailsLimit,
      limit: detailsLimit,
      personnel_id: personnel.pk,
      ...(status && { status }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationsService(objData);
      if (status === 200) {
        setViolations(data.results);
        setDetailsTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get FailureRequests Method
  const handleGetFailureRequests = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const search = isSearch ? event.target?.search?.value : "";

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      search,
      offset: ((isSearch ? 1 : detailsPageNumber) - 1) * detailsLimit,
      limit: detailsLimit,
      personnel_id: personnel.pk,
      ...(status && { status }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailureRequestsService(objData);
      if (status === 200) {
        setFailureRequests(data.results);
        setDetailsTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Invoices Method
  const handleGetInvoices = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const search = isSearch ? event.target?.search?.value : "";

    const objData = {
      search,
      offset: ((isSearch ? 1 : detailsPageNumber) - 1) * detailsLimit,
      limit: detailsLimit,
      personnel_id: personnel.pk,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getInvoicesService(objData);
      if (status === 200) {
        setInvoices(data.results);
        setDetailsTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get PaymentTransactions Method
  const handleGetPaymentTransactions = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const search = isSearch ? event.target?.search?.value : "";

    const objData = {
      search,
      offset: ((isSearch ? 1 : detailsPageNumber) - 1) * detailsLimit,
      limit: detailsLimit,
      personnel_id: personnel.pk,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPaymentTransactionsService(objData);
      if (status === 200) {
        setPaymentTransactions(data.results);
        setDetailsTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Search inputs are drafts until submitted; refreshes use the applied snapshot.
  const handleApplyPersonnelFilters = (event) => {
    event?.preventDefault();

    let from_registry_dateVal = isEmpty(from_registry_date) ? null : from_registry_date?.split("T")[0];
    let to_registry_dateVal = isEmpty(to_registry_date) ? null : to_registry_date?.split("T")[0];
    let from_quit_dateVal = isEmpty(from_quit_date) ? null : from_quit_date?.split("T")[0];
    let to_quit_dateVal = isEmpty(to_quit_date) ? null : to_quit_date?.split("T")[0];
    let from_successVal = isEmpty(from_last_successful_job) ? null : from_last_successful_job?.split("T")[0];
    let to_successVal = isEmpty(to_last_successful_job) ? null : to_last_successful_job?.split("T")[0];
    let from_unsuccessVal = isEmpty(from_last_unsuccessful_job) ? null : from_last_unsuccessful_job?.split("T")[0];
    let to_unsuccessVal = isEmpty(to_last_unsuccessful_job) ? null : to_last_unsuccessful_job?.split("T")[0];
    let from_rejectVal = isEmpty(from_last_rejected_job) ? null : from_last_rejected_job?.split("T")[0];
    let to_rejectVal = isEmpty(to_last_rejected_job) ? null : to_last_rejected_job?.split("T")[0];

    setAppliedFilters({
      search: search.trim(),
      ...(city_filter && {city: city_filter}),
      ...(isActive && { is_active: isActive }),
      ...(from_registry_dateVal && { from_registry_date: from_registry_dateVal }),
      ...(to_registry_dateVal && { to_registry_date: to_registry_dateVal }),
      ...(from_quit_dateVal && { from_quit_date: from_quit_dateVal }),
      ...(to_quit_dateVal && { to_quit_date: to_quit_dateVal }),
      ...(filterExpertType && { expert_type: filterExpertType }),
      ...(filterActivityType && { activity_type: filterActivityType }),
      ...(balanceFilter && { balance: balanceFilter }),
      
      // Use the parameter names accepted by AdminPersonnelsViewSet.
      ...(role_filter === "CONTRACTOR" && { is_contractor: true }),
      ...(role_filter === "TECHNICIAN" && { is_contractor: false }),
      ...(role_filter === "TECHNICIAN" && parent_contractor_filter && { parent_contractor: parent_contractor_filter }),
      ...(from_successVal && { from_last_successful_job: from_successVal }),
      ...(to_successVal && { to_last_successful_job: to_successVal }),
      ...(from_unsuccessVal && { from_last_unsuccessful_job: from_unsuccessVal }),
      ...(to_unsuccessVal && { to_last_unsuccessful_job: to_unsuccessVal }),
      ...(from_rejectVal && { from_last_rejected_job: from_rejectVal }),
      ...(to_rejectVal && { to_last_rejected_job: to_rejectVal }),
    });
    setPageNumber(1);
  };

  const handleGetPersonnels = useCallback(async () => {
    const requestId = ++listRequestId.current;
    const objData = {
      ...appliedFilters,
      offset: (pageNumber - 1) * limit,
      limit,
      sort_by,
      ...(type && { expertise: type }),
      ...(isSpecial !== "All" && { is_special: isSpecial }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPersonnelsService(objData);
      if (requestId !== listRequestId.current) return;
      if (status === 200) {
        if (pageNumber > 1 && objData.offset >= data.count) {
          setPageNumber(Math.max(1, Math.ceil(data.count / limit)));
          return;
        }
        setPersonnels(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (requestId === listRequestId.current && response?.status) {
        toastErrorMessage();
      }
    } finally {
      if (requestId === listRequestId.current) dispatch(setLoadingFalseAction());
    }
  }, [appliedFilters, pageNumber, limit, sort_by, type, isSpecial, dispatch]);

  useEffect(() => {
    handleGetPersonnels();
    return () => { listRequestId.current += 1; };
  }, [handleGetPersonnels]);

  // Handle Delete Personnel Method
  const handleDeletePersonnel = async (pk) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deletePersonnelService(pk);
      if (status === 200) {
        toastSuccessMessage(`پرسنل  ${pk} با موفقیت حذف شد`);
        handleGetPersonnels();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Personnel Method
  const handleCreatePersonnel = async (event) => {
    event?.preventDefault();

    let start_vacation =
      !isEmpty(vacation) && !isEmpty(vacation?.from)
        ? getCustomCalendarDate(vacation?.from)
        : null;
    let end_vacation =
      !isEmpty(vacation) && !isEmpty(vacation?.to)
        ? getCustomCalendarDate(vacation?.to)
        : null;

    const objData = {
      first_name,
      gender: gender === "" ? null : Number(gender),
      last_name,
      username,
      mobile,
      about_me,
      balance,
      shaba,
      description,
      cooperation_percentage: Number(cooperation_percentage),
      start_vacation,
      end_vacation,
      father_name,
      phone_numbers,
      business_address,
      birth_date: birth_date ? getCustomCalendarDate(birth_date) : null,
      items: [],
      deleted_items: [],
      is_active,
      is_special,
      initial_invest,
      expert_type,
      activity_type,
      working_by_foolad,
      city_id: selectedCity?.value ?? null,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createPersonnelService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage(
          `پرسنل ${first_name} ${last_name} با موفقیت ایجاد شد`
        );
        handleCloseModal();
        handleGetPersonnel(data.pk, () => {
          handleShowExpertiseModal(data.pk);
          handleGetPersonnels();
        });
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Personnel Method
  const handleEditPersonnel = async (event) => {
    event?.preventDefault();

    let start_vacation =
      !isEmpty(vacation) && vacation?.from
        ? getCustomCalendarDate(vacation?.from)
        : null;
    let end_vacation =
      !isEmpty(vacation) && vacation?.to
        ? getCustomCalendarDate(vacation?.to)
        : null;
    const currentIds = selectedTechnicians.map(t => t.pk);
    // Calculate which IDs are new, and which original ones were removed
    const add_technicians = currentIds.filter(id => !initialTechnicianIds.includes(id));
    const remove_technicians = initialTechnicianIds.filter(id => !currentIds.includes(id));
    const objData = {
      id,
      first_name,
      gender: gender === "" ? null : Number(gender),
      last_name,
      username,
      mobile,
      about_me,
      balance,
      shaba,
      description,
      cooperation_percentage: Number(cooperation_percentage),
      start_vacation,
      end_vacation,
      father_name,
      phone_numbers,
      business_address,
      birth_date: birth_date ? getCustomCalendarDate(birth_date) : null,
      items: [],
      deleted_items: [],
      is_active,
      is_special,
      initial_invest,
      expert_type,
      activity_type,
      working_by_foolad,
      city_id: selectedCity?.value ?? null,
      is_contractor,
      add_technicians,
      remove_technicians
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editPersonnelsService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage(
          `پرسنل ${first_name} ${last_name} با موفقیت ویرایش شد`
        );
        handleCloseModal();
        handleGetPersonnels();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Personnel Method
  const handleGetPersonnel = async (id, func) => {
    const objData = {
      id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPersonnelService(objData);
      if (status === 200) {
        setPersonnel(data);
        setExpertise(data.expertise);

        if (data) {
          setId(data?.pk);
          setFirst_name(data?.first_name);
          setGender(data?.gender ?? "");
          setLast_name(data?.last_name);
          setUsername(data?.username);
          setMobile(data?.mobile);
          setAbout_me(data?.about_me);
          setBirth_date(data?.birth_date);
          setFather_name(data?.father_name);
          setPhone_numbers(data?.phone_numbers);
          setBusiness_address(data?.business_address);
          setBalance(data?.balance);
          setShaba(data?.shaba);
          setDescription(data?.description);
          setCooperation_percentage(data?.cooperation_percentage);
          setInitial_invest(data?.initial_invest);
          setItems(data?.items);
          setDeleted_items(data?.deleted_items);
          setExpertise(data?.expertise);
          setIs_active(data?.is_active);
          setIs_special(data?.is_special);
          setExpert_type(data?.expert_type);
          setActivity_type(data?.activity_type);
          setWorking_by_foolad(data?.working_by_foolad);
          setIs_contractor(data?.is_contractor);
          setSelectedTechnicians(data?.technicians || []);
          setInitialTechnicianIds(data?.technicians?.map(t => t.pk) || []);
          const initialCity = data?.city
            ? cities.find(city => data.city === city.value)
            : null;
          setSelectedCity(initialCity);
          // Vacation template
          if (data?.start_vacation && data?.end_vacation) {
            const startDate = data?.start_vacation.split("T")[0].split("-");
            const endDate = data?.end_vacation.split("T")[0].split("-");
            const from = {
              year: Number(startDate[0]),
              month: Number(startDate[1]) - 1,
              day: Number(startDate[2]),
            };
            const to = {
              year: Number(endDate[0]),
              month: Number(endDate[1]) - 1,
              day: Number(endDate[2]),
            };
            setVacation({ from, to });
          } else {
            setVacation({});
          }
        }
        if (func) func();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Update Personnel Expertise Method
  const handleUpdatePersonnelExpertise = async (ui) => {
    const objData = {
      [isSelectExpertise(ui) ? "remove_expertise" : "add_expertise"]: [ui],
      id,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editPersonnelsService(objData);
      if (status === 200 || status === 201) {
        setExpertise(data.expertise);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage(response?.data?.error);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Expertise Methods
  const isSelectExpertise = (ui) => {
    return expertise?.find((s) => s?.id === ui);
  };

  // Handle Add Comment Method
  const handleAddComment = async (event, parent_id) => {
    event?.preventDefault();

    const text = event?.target?.comment?.value;

    const objData = {
      personnel_id: personnel.pk,
      text,
      ...(parent_id && { parent_id }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await addPersonnelCommentService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage("نظر شما با موفقیت ثبت شد");
        event.target.comment.value = "";
        handleGetPersonnel(personnel.pk);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Date Range
  const handleDateRange = (days) => {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - days);
    setFrom_date(fromDate.toISOString().slice(0, 10));
    setTo_date(today.toISOString().slice(0, 10));
  };

  // Upload File
  const handleUploadDocument = async (files) => {
    const formData = new FormData();
    for (const file of files) {
      const fileErrorMessage = validateFile(file);
      if (fileErrorMessage) return toastErrorMessage(fileErrorMessage);
      formData.append("files", file);
    }

    formData.append("personnel_id", personnel.pk);

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await uploadPersonnelDocumentService(formData);
      if (status === 201) {
        toastSuccessMessage("فایل با موفقیت آپلود شد");
        handleGetPersonnel(personnel.pk);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete File
  const handleDeleteDocument = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deletePersonnelDocumentService(id);
      if (status === 204) {
        toastSuccessMessage("فایل با موفقیت حذف شد");
        handleGetPersonnel(personnel.pk);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Get File
  const handleGetDocument = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPersonnelDocumentService(id);
      if (status === 200) {
        const blob = new Blob([data], { type: data.type });
        const url = URL.createObjectURL(blob);

        // Download file
        const a = document.createElement("a");
        a.href = url;
        a.download = "document";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Show file in new window
        window.open(url, "_blank");

        URL.revokeObjectURL(url);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const handleAddPersonnel = (newPersonnel) => {
    if (!selectedTechnicians.find((t) => t.pk === newPersonnel.pk)) {
      setSelectedTechnicians([...selectedTechnicians, newPersonnel]);
    }
    // Optional: clear search results after adding
    setSearchedPersonnels([]);
    setPersonnelSearch("");
  };

  const handleRemovePersonnel = (idToRemove) => {
    setSelectedTechnicians(selectedTechnicians.filter((t) => t.pk !== idToRemove));
  };

  const triggerSearch = (e) => {
    e.preventDefault(); // Prevents the main form from submitting
    handleGetSearchedPersonnels();
  };

  const handleGetSearchedPersonnels = async (event) => {
    event?.preventDefault();
    const objData = {
      search: personnelSearch,
      offset: 0,
      limit: 200,
    };

    try {
      setIsPersonnelLoading(true);
      const { status, data } = await getPersonnelsService(objData);
      if (status === 200) {
        setSearchedPersonnels(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      setIsPersonnelLoading(false);
    }
  };

  // Handle Get Contractors List for Dropdown
  const handleGetContractorsList = async () => {
    try {
      // Assuming your backend supports filtering by is_contractor via getPersonnelsService
      const { status, data } = await getPersonnelsService({ is_contractor: true, limit: 1000 });
      if (status === 200) {
        setContractorsList(data.results);
      }
    } catch (error) {
      console.error("Failed to fetch contractors list for filter");
    }
  };

  // Handle Get Personnel Logs Method
  const handleGetPersonnelLogs = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      offset: ((isSearch ? 1 : detailsPageNumber) - 1) * detailsLimit,
      limit: detailsLimit,
      personnel_id: personnel.pk, // ارسال شناسه پرسنل
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getLogsService(objData);
      if (status === 200) {
        setPersonnelLogs(data.list || data.results);
        setDetailsTotalCount(data.total || data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <personnelAdminContext.Provider
      value={{
        categories,
        setCategories,
        personnels,
        setPersonnels,
        services,
        setServices,
        violations,
        setViolations,
        failureRequests,
        setFailureRequests,
        invoices,
        setInvoices,
        paymentTransactions,
        setPaymentTransactions,
        personnel,
        setPersonnel,
        search,
        setSearch,
        filterExpertType,
        setFilterExpertType,
        filterActivityType,
        setFilterActivityType,
        handleApplyPersonnelFilters,
        handleShowCreateModal,
        type,
        setType,
        totalCount,
        setTotalCount,
        expertiseSearch,
        setExpertiseSearch,
        from_registry_date,
        setFrom_registry_date,
        to_registry_date,
        setTo_registry_date,
        from_quit_date,
        setFrom_quit_date,
        to_quit_date,
        setTo_quit_date,
        activeTab,
        setActiveTab,
        // Personnel Create And Update Item
        id,
        setId,
        first_name,
        gender,
        setGender,
        setFirst_name,
        last_name,
        setLast_name,
        username,
        setUsername,
        mobile,
        setMobile,
        about_me,
        setAbout_me,
        birth_date,
        setBirth_date,
        father_name,
        setFather_name,
        phone_numbers,
        setPhone_numbers,
        business_address,
        setBusiness_address,
        balance,
        setBalance,
        balanceFilter,
        setBalanceFilter,
        shaba,
        setShaba,
        cooperation_percentage,
        setCooperation_percentage,
        initial_invest,
        setInitial_invest,
        vacation,
        setVacation,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        status,
        setStatus,
        isSpecial,
        setIsSpecial,
        is_contractor,
        setIs_contractor,
        selectedTechnicians,
        setSelectedTechnicians,
        searchedPersonnels,
        setSearchedPersonnels,
        isPersonnelLoading,
        setIsPersonnelLoading,
        personnelSearch,
        setPersonnelSearch,
        handleAddPersonnel,
        handleRemovePersonnel,
        triggerSearch,
        role_filter,
        setRole_filter,
        parent_contractor_filter,
        setParent_contractor_filter,
        contractorsList,
        setContractorsList,
        handleGetContractorsList,
        isActive,
        setIsActive,
        items,
        setItems,
        deleted_items,
        setDeleted_items,
        is_active,
        setIs_active,
        is_special,
        setIs_special,
        isShowModal,
        setIsShowModal,
        pageNumber,
        setPageNumber,
        expert_type,
        setExpert_type,
        activity_type,
        setActivity_type,
        sort_by,
        setSort_by,
        working_by_foolad,
        setWorking_by_foolad,
        limit,
        setLimit,
        detailsTotalCount,
        setDetailsTotalCount,
        detailsPageNumber,
        setDetailsPageNumber,
        detailsLimit,
        setDetailsLimit,
        isShowDetailsModal,
        setIsShowDetailsModal,
        description,
        setDescription,
        expertise,
        setExpertise,
        isShowExpertiseModal,
        isSelectExpertise,
        setIsShowExpertiseModal,
        isShowAdvancedSearch,
        setIsShowAdvancedSearch,
        handleShowExpertiseModal,
        handleCloseExpertiseModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetCategories,
        handleGetViolations,
        handleGetFailureRequests,
        handleGetInvoices,
        handleGetPaymentTransactions,
        handleGetPersonnels,
        handleDeletePersonnel,
        handleCreatePersonnel,
        handleGetPersonnel,
        handleUpdatePersonnelExpertise,
        handleSearchServices,
        handleGetServices,
        handleEditPersonnel,
        handleAddComment,
        handleDateRange,
        handleUploadDocument,
        handleDeleteDocument,
        handleGetDocument,
        city_filter,
        setCity_filter,
        cities,
        selectedCity,
        setSelectedCity,
        from_last_successful_job, setFrom_last_successful_job,
        to_last_successful_job, setTo_last_successful_job,
        from_last_unsuccessful_job, setFrom_last_unsuccessful_job,
        to_last_unsuccessful_job, setTo_last_unsuccessful_job,
        from_last_rejected_job, setFrom_last_rejected_job,
        to_last_rejected_job, setTo_last_rejected_job,
        personnelLogs,
        handleGetPersonnelLogs
      }}
    >
      {children}
    </personnelAdminContext.Provider>
  );
};

export default PersonnelAdminContext;
